import {useMemo} from "react";
import {IStateInitiativeFilters} from "../pages/StateInitiative/StateInitiative.type";

interface FilteredInitiativesProps {
  participantsData: any[];
  filters: IStateInitiativeFilters;
  isBenefitsSubsidies: boolean;
}

export const useFilteredInitiatives = ({
  participantsData,
  filters,
  isBenefitsSubsidies,
}: FilteredInitiativesProps) => {
  const filteredData = useMemo(() => {
    if (!participantsData || participantsData.length === 0) {
      return [];
    }

    const filteredResult = participantsData.filter((item) => {
      // ОТКЛЮЧЕН: Фильтр по драйверам
      // if (filters?.drivers?.turnOn && filters?.drivers?.value?.length > 0) {
      //   if (item.driver?.documentId) {
      //     const hasSelectedDriver = filters.drivers.value.includes(
      //       item.driver.documentId
      //     );
      //     if (!hasSelectedDriver) return false;
      //   } else {
      //     return false; // Если нет драйвера, исключаем из результатов
      //   }
      // }

      if (filters.gpb.turnOn && filters.gpb.value !== "all") {
        if (item.gpb === null || item.gpb === undefined) {
          return false;
        }

        if (filters.gpb.value === "true" && item.gpb !== true) {
          return false;
        }
        if (filters.gpb.value === "false" && item.gpb === true) {
          return false;
        }
      }

      if (filters.priority_level.turnOn && filters.priority_level.value !== 0) {
        if (item.priority === null || item.priority === undefined) {
          return false;
        }

        const expectedPriority =
          filters.priority_level.value === 1
            ? "Низкий"
            : filters.priority_level.value === 2
            ? "Средний"
            : filters.priority_level.value === 3
            ? "Высокий"
            : null;

        if (expectedPriority && item.priority !== expectedPriority) {
          return false;
        }
      }

      if (
        filters.business_impact.turnOn &&
        filters.business_impact.value !== 0
      ) {
        if (
          item.business_impact === null ||
          item.business_impact === undefined
        ) {
          return false;
        }

        const expectedBusinessImpact =
          filters.business_impact.value === 1
            ? "Низкий"
            : filters.business_impact.value === 2
            ? "Средний"
            : filters.business_impact.value === 3
            ? "Высокий"
            : null;

        if (
          expectedBusinessImpact &&
          item.business_impact !== expectedBusinessImpact
        ) {
          return false;
        }
      }

      if (
        filters.lobbying_capability.turnOn &&
        filters.lobbying_capability.value > 0
      ) {
        if (
          item.lobbying_opportunity === null ||
          item.lobbying_opportunity === undefined
        ) {
          return false;
        }

        const expectedLobbyingLevel =
          filters.lobbying_capability.value === 1
            ? "Низкая"
            : filters.lobbying_capability.value === 2
            ? "Средняя"
            : filters.lobbying_capability.value === 3
            ? "Высокая"
            : null;

        if (
          expectedLobbyingLevel &&
          item.lobbying_opportunity !== expectedLobbyingLevel
        ) {
          return false;
        }
      }

      if (isBenefitsSubsidies) {
        if (item.has_benefits === null || item.has_benefits === undefined) {
          return false;
        }

        if (!item.has_benefits) {
          return false;
        }
      }

      if (filters.lifecycle_stage.turnOn) {
        if (filters.lifecycle_stage.value.length === 0) {
          return false;
        }

        if (
          item.lifecycle_stage === null ||
          item.lifecycle_stage === undefined
        ) {
          return false;
        }

        if (!filters.lifecycle_stage.value.includes(item.lifecycle_stage)) {
          return false;
        }
      } else {
      }

      if (filters.obligation_level.turnOn) {
        if (filters.obligation_level.value.length === 0) {
          return false;
        }

        if (filters.obligation_level.value.length === 3) {
        } else {
          if (
            item.obligation_level === null ||
            item.obligation_level === undefined
          ) {
            return false;
          }

          if (!filters.obligation_level.value.includes(item.obligation_level)) {
            return false;
          }
        }
      } else {
      }

      if (filters.participation_formats.turnOn) {
        if (filters.participation_formats.value.length === 0) {
          return false;
        }

        if (filters.participation_formats.value.length === 3) {
        } else {
          if (
            item.participation_formats === null ||
            item.participation_formats === undefined
          ) {
            return false;
          }

          if (
            !filters.participation_formats.value.includes(
              item.participation_formats
            )
          ) {
            return false;
          }
        }
      } else {
      }

      // Фильтрация по зонам влияния (impact_areas)
      if (filters.influence_zone.turnOn) {
        if (filters.influence_zone.value.length === 0) {
          return false;
        }

        // Проверяем, есть ли у инициативы поле impact_areas
        if (!item.impact_areas || !Array.isArray(item.impact_areas)) {
          return false;
        }

        if (item.impact_areas.length === 0) {
          return false;
        }

        // Ищем пересечения между именами зон влияния инициативы и выбранными в фильтре
        const initiativeImpactAreaNames = item.impact_areas.map(
          (area: any) => area.name
        );

        const hasMatchingImpactArea = filters.influence_zone.value.some(
          (selectedZone: string) =>
            initiativeImpactAreaNames.includes(selectedZone)
        );

        if (!hasMatchingImpactArea) {
          return false;
        }
      }
      return true;
    });

    return filteredResult;
  }, [participantsData, filters, isBenefitsSubsidies]);

  return filteredData;
};
